module.exports = __webpack_public_path__ + "static/media/fckngserious.e71079dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/fckngserious.png
// module id = 206
// module chunks = 0